import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import { BrowserRouter } from 'react-router';
import gsap from 'gsap';
import { CSSPlugin } from 'gsap/CSSPlugin';
import { CustomEase } from 'gsap/CustomEase';
import './components.css';
import './mobile.css';
import { scrollToTop } from './components/Router/Router';
import useEditorStore from './components/Editor/EditorStore';
import 'modern-normalize/modern-normalize.css';
import '@fontsource/montserrat/300.css';
import { useSafariPageReload } from './utils';
import usePageStore from './components/Page/pageStore';
import useDataStore from './components/Data/dataStore';
function App() {
    const activePage = usePageStore((state) => state.activePage);
    const content = useDataStore((state) => state.data[activePage]);
    const { editCurve } = useEditorStore();
    useSafariPageReload();
    const mounted = useRef(false);
    useEffect(() => {
        if (mounted.current)
            return;
        mounted.current = true;
        gsap.registerPlugin(CSSPlugin);
        gsap.registerPlugin(CustomEase);
        setTimeout(() => window.scrollTo(scrollToTop), 10);
        setTimeout(() => window.scrollTo(scrollToTop), 100);
        /* document.addEventListener('mousedown', () => setPaused(true));
        document.addEventListener('mouseup', () => setPaused(false)); */
        if ('scrollRestoration' in window.history) {
            window.history.scrollRestoration = 'manual';
        }
        const wrapper = document.querySelector('.page-wrapper');
        if (wrapper) {
            wrapper.style.opacity = '1';
        }
    }, []);
    useEffect(() => {
        const { name, description } = content ?? {};
        document.title = `Test${name ? ` - ${name}` : ''}`;
        const desc = document.querySelector('meta[name="description"]');
        desc?.setAttribute('content', description ??
            'test');
    }, [activePage, content]);
    return (_jsx(BrowserRouter, { children: 'Silence is golden' }));
}
export default App;
